import { IExtendedSearchData } from "src/api/server/extended-search";
import { EnumSortDirectionName } from "src/types/common";
import { EnumSearchQueryParams } from "../search.types";
import { ISearchStore } from "../store/search-store";
import { mapKeyFiguresFromQuery } from "./map-key-figures";
import { mapLeverageProductsIndicationFromQuery } from "./map-leverage-products-indication";
import { mapSelectedRankingFromQuery } from "./map-selected-ranking";
import { mapTagsFromQuery } from "./map-tags";

const getSortDirectionValue = (sortDirection: string) => (sortDirection === EnumSortDirectionName.Descending ? 1 : 0);

export const mapSearchParamsToState = (urlParams: URLSearchParams, extendedSearchData: IExtendedSearchData): ISearchStore => {
    const sortDirectionParam = urlParams.get(EnumSearchQueryParams.SortDirection);

    const sortDirection = sortDirectionParam ? getSortDirectionValue(sortDirectionParam) : null;
    const selectedRanking = mapSelectedRankingFromQuery(urlParams, sortDirection, extendedSearchData.rankingsData);
    const allKeyFigures = extendedSearchData.keyFiguresData.keyFiguresGroups.flatMap(keyFigureGroup => keyFigureGroup.keyFigures);
    const popularKeyFigures = extendedSearchData.keyFiguresData.popularKeyFiguresGroup.keyFigures;
    const allKeyFiguresWithIsPopularIndication = allKeyFigures.map(keyFigure => {
        return { ...keyFigure, isPopular: popularKeyFigures.some(popularKeyFigure => popularKeyFigure.id == keyFigure.id) };
    });

    const state: ISearchStore = {
        query: urlParams.get(EnumSearchQueryParams.SearchTerm) ?? "",
        keyFigures: mapKeyFiguresFromQuery(urlParams, allKeyFiguresWithIsPopularIndication),
        tags: mapTagsFromQuery(urlParams, extendedSearchData.tagsData),
        selectedRanking: selectedRanking,
        sortDirection: sortDirection,
        brokersIds: urlParams.get(EnumSearchQueryParams.BrokerIds)?.split(",") ?? [],
        isInvestable: urlParams.get(EnumSearchQueryParams.IsInvestable) === "true",
        isAtInvestable: urlParams.get(EnumSearchQueryParams.IsAtInvestable) === "true",
        isChInvestable: urlParams.get(EnumSearchQueryParams.IsChInvestable) === "true",
        leverageProductsIndication: mapLeverageProductsIndicationFromQuery(urlParams),
    };

    return state;
};
